import * as React from "react"

function SvgChevronRight(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 16 27"
      {...props}
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M1.649 25.537a.499.499 0 01-.374-.17.505.505 0 01.043-.709l12.575-11.18L1.318 2.298a.503.503 0 11.662-.754l12.576 11.181a1.012 1.012 0 01.001 1.503L1.98 25.412a.498.498 0 01-.331.126z"
      />
    </svg>
  )
}

export default SvgChevronRight
